import { render, staticRenderFns } from "./CoordinatesForm.vue?vue&type=template&id=6237c795"
import script from "./CoordinatesForm.vue?vue&type=script&lang=js"
export * from "./CoordinatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports